import live_bulb from './live-bulb.svg';
import live_coffee from './live-coffee.svg';
import live_coffee_to_go from './live-coffee-to-go.svg';
import live_cookie from './live-cookie.svg';
import live_cupcake from './live-cupcake.svg';
import live_first_aid from './live-first-aid.svg';
import live_leaf from './live-leaf.svg';
import live_moon from './live-moon.svg';
import live_planet from './live-planet.svg';
import live_puzzle from './live-puzzle.svg';
import live_rainbow from './live-rainbow.svg';
import live_snow from './live-snow.svg';
import live_sun from './live-sun.svg';
import live_water_drop from './live-water-drop.svg';

export const V2_LIVE_ICONS: { [char: string]: string } = {
  live_bulb,
  live_coffee,
  live_coffee_to_go,
  live_cookie,
  live_cupcake,
  live_first_aid,
  live_leaf,
  live_moon,
  live_planet,
  live_puzzle,
  live_rainbow,
  live_snow,
  live_sun,
  live_water_drop,
};

export const V2_LIVE_ICON_NAMES: string[] = Object.keys(V2_LIVE_ICONS);
